import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0534b608")

_pushScopeId("data-v-0534b608")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "l-talent-list" }, null, -1)
const _hoisted_2 = { class: "txt txt txt-medium name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("a", {
    class: "talent-list-card l-talent-list",
    style: { backgroundImage: 'url(' + _ctx.imageSrc + ')' },
    href: _ctx.url,
    target: "_blank"
  }, [
    _hoisted_1,
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.message), 1)
  ], 12, ["href"]))
})